import { useEffect } from 'react';

import { getLocale } from 'shared/utils/getLocale';
import { PaymentType } from 'shared/enums/PaymentType';
import { useCheckoutContext } from 'checkout/providers/CheckoutContextProvider';
import { useLocation } from 'shared/hooks/useLocation';

/**
 * This extremely ugly inlined code is part of the script tag provided by Affirm to load their SDK
 *
 * Because we require a nonce for CSP, it's causing us a lot of trouble trying to selectively loading only
 * on checkout between serverside renders and client renders. This is a workaround.
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */
export const Affirm = () => {
  const { availablePaymentMethods } = useCheckoutContext();
  const { selectedCountryCode } = useLocation();
  const { publicKey, scriptUrl } = availablePaymentMethods[PaymentType.Affirm] || {};

  const isCAD = selectedCountryCode === 'CA';

  const locale = isCAD ? 'en-ca' : getLocale();
  // Affirm requires locale in the format of 'en_US' or 'en_CA'
  const [language, region] = locale.split('-');
  const formatedLocale = `${language}_${region.toUpperCase()}`;

  // Affirm requires 3 letter country code. Might get this from PEAS soon.
  const threeLetterCountryCode = selectedCountryCode === 'CA' ? 'CAN' : 'USA';

  useEffect(() => {
    if (publicKey && scriptUrl && formatedLocale && threeLetterCountryCode) {
      // https://docs.affirm.com/developers/v1.0-Global-Integration/docs/global-affirm-integration-guide
      // @ts-ignore
      window._affirm_config = {
        public_api_key: publicKey,
        script: scriptUrl,
        locale: formatedLocale,
        country_code: threeLetterCountryCode,
      };

      // @ts-ignore
      (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=!0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");
    }
  }, [formatedLocale, publicKey, scriptUrl, threeLetterCountryCode, scriptUrl]);

  return null;
};
